import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { HistoryFavoriteGetModel } from './history-favorite-get.state';

/** StateDetailsActions */
const ACTION_SET = '[HistoryFavoriteGet] set';
const ACTION_UPDATE = '[HistoryFavoriteGet] update';
const ACTION_RESET = '[HistoryFavoriteGet] reset';
const ACTION_FAIL = '[HistoryFavoriteGet] fail';
const ACTION_CANCEL_REQUEST = '[HistoryFavoriteGet] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[HistoryFavoriteGet] set from api';
const ACTION_UPDATE_FROM_API = '[HistoryFavoriteGet] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setHistoryFavoriteGet = createAction(ACTION_SET, props<WithRequestId<HistoryFavoriteGetModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateHistoryFavoriteGet = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<HistoryFavoriteGetModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetHistoryFavoriteGet = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelHistoryFavoriteGetRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failHistoryFavoriteGet = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setHistoryFavoriteGetFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<HistoryFavoriteGetModel>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateHistoryFavoriteGetFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<HistoryFavoriteGetModel>>()
);
